import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { User, Tag } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { ROUTES, USER_ROLES } from '../../utils/constants';
import { clsx } from 'clsx';

/** Profile area nav: Overview + Coupons (only for DEV_TEAM). Used on /profile and /profile/coupons. */
export const ProfileNav: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();
  const isDev = user?.roles?.includes(USER_ROLES.DEV_TEAM) ?? false;

  const navItems = [
    { label: 'Overview', to: ROUTES.PROFILE, icon: User },
    ...(isDev ? [{ label: 'Coupons', to: ROUTES.PROFILE_COUPONS, icon: Tag }] : []),
  ];

  return (
    <nav className="space-y-0.5">
      {navItems.map(({ label, to, icon: Icon }) => {
        const isActive = location.pathname === to;
        return (
          <Link
            key={to}
            to={to}
            className={clsx(
              'flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
              isActive
                ? 'bg-primary-100 text-primary-700 dark:bg-primary-900/50 dark:text-primary-300'
                : 'text-app-text-muted dark:text-gray-400 hover:bg-app-surface-muted dark:hover:bg-gray-800 hover:text-app-text dark:hover:text-white'
            )}
          >
            <Icon className="h-4 w-4 shrink-0" />
            {label}
          </Link>
        );
      })}
    </nav>
  );
};
